
    import { Observable } from 'rxjs';
    import { UseCase } from '../../base/use-case';
    import { ConsultRepository } from '../../repositories/consult.repository';
    import { AnalysisMarchPhysiotherapyModel } from '../../models/consult/analysis-march-physiotherapy.model';
    import { AnalysisMarchPhysiotherapyResponseModel } from '../../models/consult/analysis-march-physiotherapy-response.model';
    
    export class UpdateAnalysisMarchPhysiotherapyUseCase implements UseCase<AnalysisMarchPhysiotherapyModel, AnalysisMarchPhysiotherapyResponseModel> {
        constructor(private consult: ConsultRepository) { }
        execute(params: AnalysisMarchPhysiotherapyModel): Observable<AnalysisMarchPhysiotherapyResponseModel> {
        return this.consult.updateAnalysisMarchPhysiotherapy(params);
        }
    }